import React, { useContext, useMemo, useState } from 'react';

import useOrchestrationList from '../../../utils/hooks/use_orchestration_list';

const OrchestrationSearchContext = React.createContext({
  error: null,
  loading: false,
  orchestrations: [],
  searchQuery: '',
  setSearchQuery: () => { },
});

const useOrchestrationSearchQuery = (query = '', orchestrationData = []) => {
  const [searchQuery, setSearchQuery] = useState(query);

  const orchestrations = orchestrationData?.filter(({ name }) => {
    if (!name) { // Null names appear to be allowed??
      return true;
    }
    return name?.toLowerCase().includes(searchQuery.toLowerCase())
  })
  return {
    searchQuery,
    orchestrations,
    setSearchQuery,
  };
};

export const OrchestrationSearchProvider = ({ children, query = '' }) => {
  const { orchestrationData, loading, error } = useOrchestrationList();
  const {
    orchestrations,
    searchQuery,
    setSearchQuery,
  } = useOrchestrationSearchQuery(query, orchestrationData)

  const orchestrationSearchContextValue = useMemo(() => ({
    orchestrations,
    loading,
    error,
    searchQuery,
    setSearchQuery,
  }), [
    orchestrations,
    loading,
    error,
    searchQuery,
    setSearchQuery,
  ])

  return (
    <OrchestrationSearchContext.Provider
      value={orchestrationSearchContextValue}
    >
      {children}
    </OrchestrationSearchContext.Provider>
  )
}

export const useOrchestrationSearch = () => useContext(OrchestrationSearchContext);

export default useOrchestrationSearch;
